<template>
  <transition name="slide-fade">
    <div id="aboutusHolder">
      <!--<div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
        <div class="uk-container uk-container-small">
          <p class="uk-text-center uk-text-lead@l uk-text-large@l">
            <i>"Providing a hand to hold from start to finish"</i>
          </p>
        </div>
      </div>-->
      <div class="uk-padding">
        <h1 class="uk-heading-line specHeading uk-text-center"><span>Scholarships and Student Aid</span></h1>
        <div class="uk-container uk-container-small">
          <div class="uk-child-width-1-2@m" uk-grid>
            <div>
              <img src="../assets/scholar.jpg" alt="">
            </div>
            <div>
              <h4 class="uk-heading-bullet specHeading">Who qualifies for a Scholarship?</h4>
              <p class="">
                Students who meet the basic requirements of Grade Point Average (GPA),
                citizenship, work/study participation and demonstration of financial need must
                apply before the stated deadline. <br>
                <span class="uk-text-primary"><i>Conditions apply based on donors’ criteria.</i></span>

                <br><br><br>
                <router-link to="/financialaid" class="uk-button uk-button-default uk-align-right">See Financial Aid <span uk-icon="arrow-right"></span></router-link>
              </p>
            </div>

          </div>

        </div>
      </div>
      <div class="uk-padding " style="background-image: url('../../../static/rec.jpg')">
        <div class="uk-container uk-container-small uk-light uk-overlay-primary uk-padding" >
         <!-- <h2 class="uk-heading-line uk-text-center  specHeading" style="color: white !important;">Honours</h2>-->
          <div class="uk-child-width-1-2@m" uk-grid>
            <div>
              <h4 class="uk-heading-bullet specHeading">How do we help?</h4>
              <small class="uk-text-muted">We offer to our students more than just monetary support:</small>
              <ul class="uk-list uk-list-bullet ">

                <li class="">On – campus job placements</li>
                <li class="">Scholarships/ Bursaries/ Grants</li>
                <li class="">Financial Aid</li>
                <li class="">Groceries</li>
                <li class="">Articles of clothing</li>
                <li class="">Mentorship</li>
                <li>
                  Act as Laision Officer for Government Programmes such as:
                  <ul class="uk-list uk-list-bullet">
                    <li>JAMVAT</li>
                    <li>PATH</li>
                    <li>NYS</li>
                    <li>And Others</li>
                  </ul>
                </li>


              </ul>
            </div>
            <div>
              <div>
                <h4 class="uk-heading-bullet specHeading">How do I know when a scholarship is available?</h4>
                <span class="uk-text-muted ">
                Scholarships are mainly advertised via Corporation Communications’ e-bulletin twice daily.
                </span>
                <ul class="uk-list uk-list uk-list-bullet ">
                  You may also check the following:
                  <li>The Sunday Gleaner</li>
                  <li>Scholarships To Go website</li>
                </ul>
                <h4 class="uk-heading-bullet specHeading">How are scholarships Disbursed?</h4>
                <span class="uk-text-muted ">
                The scholarships Committee interviews applicants who have been shortlisted for the advertised scholarships.
              </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-padding uk-background-muted">

        <div class="uk-container uk-container-small">
          <div class="uk-child-width-1-1@m" uk-grid>

            <div>
              <h3 class="uk-heading-bullet specHeading "><span>Scholarship Offerings</span></h3>
              <div>
                <p class="uk-heading-bullet  specHeading">President’s Award for Excellence</p>
                <span class="">
                Applicant must be a recent graduate from high school with a minimum of ten (10) CSEC, GCE, CAPE subjects in one’s (1’s) and two’s (2’s) possessing leadership skills.
              </span>
              </div>
            </div>

          </div>
          <div class="uk-child-width-1-2@m" uk-grid>
            <div class="uk-align-center">
              <table class="uk-table uk-table-divider uk-table-striped">
                <caption>Criteria for scholarships are sent out when the scholarship is being offered</caption>
                <thead>
                <tr>
                  <th>Name of Scholarship</th>
                  <th>Amount</th>

                </tr>
                </thead>
                <tbody class="uk-text-small">
                <tr>
                  <td>Adrian T. Westney Sr.</td>
                  <td>US $1,000.00</td>
                </tr>
                <tr>
                  <td>Byron Robinson Educational Foundation</td>
                  <td>US $1,000.00</td>
                </tr>
                <tr>
                  <td>Cinderella Thomas</td>
                  <td>JMD $100,000.00</td>
                </tr>
                <tr>
                  <td>Courts Unicomer</td>
                  <td>JMD $250,000.00</td>
                </tr>
                <tr>
                  <td>Digicel</td>
                  <td>JMD $145,000.00</td>
                </tr>
                <tr>
                  <td>Jamaica National</td>
                  <td>JMD $130,000.00</td>
                </tr>
                <tr>
                  <td>Ja. Police Co-op Credit Union</td>
                  <td>JMD $165,000.00</td>
                </tr>


                </tbody>
              </table>
            </div>
            <div>
              <br>
              <table class="uk-table uk-table-divider uk-table-striped">

                <thead>
                <tr>
                  <th>Name of Scholarship</th>
                  <th>Amount</th>

                </tr>
                </thead>
                <tbody class="">

                <tr>
                  <td>L.A. Buchanan 3-year</td>
                  <td>JMD $150,000.00</td>
                </tr>
                <tr>
                  <td>Linvol G. & Lorna D. Henry</td>
                  <td>JMD $75,000.00</td>
                </tr>
                <tr>
                  <td>New York Chapter</td>
                  <td>US $500.00</td>
                </tr>
                <tr>
                  <td>Pacific Coast Chapter</td>
                  <td>US $750.00</td>
                </tr>
                <tr>
                  <td>Robert & Mary Kennedy Centenary</td>
                  <td>US $500.00</td>
                </tr>
                <tr>
                  <td>Sagicor Foundation</td>
                  <td>JMD $250,000.00</td>
                </tr>

                </tbody>
              </table>
            </div>
          </div>


        </div>
      </div>


    </div>
  </transition>
</template>

<script>
    export default {
        name: "ssa",
      mounted(){
        window.scrollTo(0, 0);
      },
      metaInfo: {
        // Children can override the title.
        title: 'NCU Scholarship and Student Aid',
        // Result: My Page Title ← My Site
        // If a child changes the title to "My Other Page Title",
        // it will become: My Other Page Title ← My Site
        //titleTemplate: '%s ← My Site',
        // Define meta tags here.
        meta: [
          {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
          {name: 'viewport', content: 'width=device-width, initial-scale=1'},
          {name: 'description', content: 'Department of Scholarship and Student Aid at Northern Caribbean University '}
        ]
      }
    }
</script>

<style scoped>
  @media screen and (max-width:600px){


    h4{
      font-size: 1.1em !important;
    }
    h1{
      font-size: 1.2em !important;
    }
    p,li{
      font-size: 0.8em !important;
    }


  }

</style>
